// extracted by mini-css-extract-plugin
export default {"disableMultiSelect":"webhook-model-tree_disableMultiSelect__QyG41"};